import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const Pages = () => {
  const labels = ["Page 1", "Page 2", "Page 3", "Page 4", "Page 5"];
  const values = [75, 55, 35, 45, 65];

  const data = {
    labels: labels, // Needed for internal mapping
    datasets: [
      {
        data: values,
        backgroundColor: "#52279B",
        borderRadius: 8,
        barThickness: 50,
        datalabels: {
          display: true,
          align: "start",
          anchor: "start",
          formatter: (_, context) => labels[context.dataIndex], // 🏷️ Label on left
          color: "#f8f9fa",
          font: {
            size: 12,
            weight: "bold"
          },
          padding: { left: 8 },
        },
      },
      {
        label: "Values",
        data: values,
        backgroundColor: "transparent", // invisible layer
        datalabels: {
          display: true,
          align: "end",
          anchor: "end",
          formatter: (value) => `${value}%`, // 📊 Value on right
          color: "#333",
          font: {
            size: 12,
            weight: "bold"
          },
          padding: { right: 8 },
        },
      },
    ],
  };

  const options = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: false, // Disable native tooltip (optional)
      },
      datalabels: {
        clip: false
      }
    },
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          callback: (val) => `${val}%`,
          color: "#999"
        },
        grid: { color: "#eee" }
      },
      y: {
        display: false, // ❌ Remove y-axis labels
        grid: { display: false }
      }
    }
  };

  return (
    <div style={{ height: "412px", maxWidth: "585px", marginTop: "20px" }}>
      <Bar data={data} options={options} plugins={[ChartDataLabels]} />
    </div>
  );
};

export default Pages;
